
<div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-5">
                <div class="logo" style="text-align: center;">
                    <img src="assets/logoblanco.png" style="width: 300px;">
                </div>
                <div class="card shadow-lg border-0 rounded-lg mt-5">
                    <div class="card-header"><h3 class="text-center font-weight-light my-4">Ingreso administrativo PTW</h3></div>
                    <div class="card-body">
                        
                        <ngb-alert *ngIf="autenticando ==true " ><strong>Autenticando...</strong> <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span> </ngb-alert>
                        <div *ngIf="alertaActiva">
                            <p>
                                <ngb-alert [type]="tipodeAlerta" (close)="closeAlert()">{{ mensajeAlerta }}</ngb-alert>
                            </p>
                        </div>
                        
                        <!-- <form> -->
                            <div class="form-group"><label class="small mb-1" for="inputEmailAddress">Email</label><input class="form-control py-4" id="inputEmailAddress" type="email" placeholder="Enter email address" [(ngModel)]="email" /></div>
                            <div class="form-group"><label class="small mb-1" for="inputPassword">Clave</label><input class="form-control py-4" id="inputPassword" type="password" placeholder="Enter password"  [(ngModel)]="password"/></div>
                            
                        <!-- </form> -->
                    </div>
                    <div class="card-footer text-center">
                        <!-- <div class="form-group d-flex align-items-center justify-content-between mt-4 mb-0"><button class="btn bt-primary" (click)="openModalForgotpassword()">Olvidé mi clave</button><a class="btn btn-primary" (click)="login()" routerLink="/menu-component">Ingresar</a></div> -->
                        <div class="form-group d-flex align-items-center justify-content-between mt-4 mb-0"><a class="btn btn-primary btn-block" (click)="login()" routerLink="/menu-component">Ingresar</a></div>
                    </div>
                </div>
            </div>
        </div>
    </div>


